import api from '../../utils/axios';

export const subscriptionService = {
  getMySubscription: async () => {
    const response = await api.get('/agent/my-subscription');
    return response.data;
  },

  getAvailablePlans: async () => {
    const response = await api.get('/agent/available-plans');
    return response.data;
  },

  getCustomLinkDetails: async (token) => {
    const response = await api.get(`/agent/custom-link-details?token=${token}`);
    return response.data;
  },

  getCustomLinkStatus: async (token) => {
    const response = await api.get(`/agent/custom-link-status?custom_token=${token}`);
    return response.data;
  },

  createCheckout: async (planId, billingInterval = 'month', options = {}) => {
    const response = await api.post('/agent/subscribe', { 
      plan_id: planId, 
      billing_interval: billingInterval,
      ...options
    });
    return response.data;
  },

  verifyPayment: async (data) => {
    const response = await api.post('/agent/verify-subscription', data);
    return response.data;
  },

  checkPendingCheckout: async (params) => {
    const response = await api.get('/agent/check-pending-checkout', { params });
    return response.data;
  },

  cancelSubscription: async (reason) => {
    const response = await api.post('/agent/cancel-subscription', { cancellation_reason: reason });
    return response.data;
  },

  pauseSubscription: async (months) => {
    const response = await api.post('/agent/pause-subscription', { pause_months: months });
    return response.data;
  },

  resumeSubscription: async () => {
    const response = await api.post('/agent/resume-subscription');
    return response.data;
  },

  getPaymentHistory: async () => {
    const response = await api.get('/agent/payment-history');
    return response.data;
  },

  createUpdatePaymentMethodSession: async () => {
    const response = await api.post('/agent/create-payment-method-update-session');
    return response.data;
  },

  verifyUpdatePaymentMethod: async (data) => {
    const response = await api.post('/agent/verify-payment-method-update', data);
    return response.data;
  },

  createSubscriptionRequest: async (payload) => {
    const response = await api.post('/agent/subscription-request', payload);
    return response.data;
  },

  getMySubscriptionRequests: async () => {
    const response = await api.get('/agent/subscription-requests');
    return response.data;
  },

  cancelSubscriptionRequest: async (requestId) => {
    const response = await api.post('/agent/cancel-subscription-request', { request_id: requestId });
    return response.data;
  },

  authorizePendingPlan: async () => {
    const response = await api.post('/agent/authorize-pending-plan');
    return response.data;
  },

  verifyPendingPlan: async (data) => {
    const response = await api.post('/agent/verify-pending-plan', data);
    return response.data;
  },

  upgradeSubscription: async (targetPlanId) => {
    const response = await api.post('/agent/subscription-upgrade', { target_plan_id: targetPlanId });
    return response.data;
  }
};
